import ReactMarkdown from 'react-markdown'
import type { Components } from 'react-markdown'
import { begreppRehypePlugin } from '../lib/begrepp'
import { MARKDOWN_TILLAGG } from '../lib/markdown'
import Illustration from './Illustration'

// Bilder renderas som centrerade illustrationer med bildtext. En bild som är
// enda barn i ett stycke wrappas annars i <p>, så stycken som bara innehåller
// en bild renderas utan <p>-hölje (illustrationen är själv ett block).
const BAS_KOMPONENTER: Components = {
  img: ({ src, alt }) => <Illustration src={typeof src === 'string' ? src : undefined} alt={alt} />,
  p: ({ children, node }) => {
    const barn = node?.children ?? []
    if (barn.length === 1 && barn[0].type === 'element' && barn[0].tagName === 'img') {
      return <>{children}</>
    }
    return <p>{children}</p>
  },
}

/**
 * Renderar lärotext som markdown (stycken, **fetstil**, punkt- och
 * nummerlistor, samt ![]()-illustrationer) och markerar automatiskt begrepp ur
 * den gemensamma begreppsdatabasen. Hover eller tangentbordsfokus på ett
 * markerat begrepp visar förklaringen (se .begrepp-mark i global.css).
 */
export default function MarkeradText({ markdown, styckeKlass }: { markdown: string; styckeKlass?: string }) {
  const components: Components = styckeKlass
    ? {
        ...BAS_KOMPONENTER,
        p: ({ children, node }) => {
          const barn = node?.children ?? []
          if (barn.length === 1 && barn[0].type === 'element' && barn[0].tagName === 'img') {
            return <>{children}</>
          }
          return <p className={styckeKlass}>{children}</p>
        },
      }
    : BAS_KOMPONENTER

  return (
    <ReactMarkdown components={components} remarkPlugins={MARKDOWN_TILLAGG} rehypePlugins={[begreppRehypePlugin]}>
      {markdown}
    </ReactMarkdown>
  )
}
